import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";

// 页面路由配置
import routes from './router'

// 路由参数配置
const router = createRouter({
    history:createWebHistory(),
    routes
})

// 全局前置守卫
router.beforeEach((to,from,next)=>{
    next()
})

//全局后置钩子
router.afterEach((to,from)=>{
    const title = to.meta.title
    if(title) {
        window.document.title = title
    }
})

export  default router